import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { CustomConfirmDialogService } from 'src/app/services/Non-Master/CustomConfirmDialog.service';
import { LoggerService } from 'src/app/services/Non-Master/logger.service';
import { MatTableDataSource, MatPaginator } from '@angular/material';
import { MastersKeyStringValue } from 'src/app/services/Non-Master/MastersKeyStringValue.service';
import { AppSettings } from 'src/app/shared/AppSettings';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SystemDefaultModel, ChineseDefaultModel, EnglishDefaultModel } from 'src/app/models/non-master-model/SystemDefaultModel';
import { AppComponent } from 'src/app/app.component';
import { FormControl } from '@angular/forms';

import { tPatientTypeService } from 'src/app/services/tPatientType.service';
import { tPatientTypeModel } from 'src/app/models/tPatientTypeModel';


@Component({
  selector: 'app-search-patient-type-dialog',
  templateUrl: './search-patient-type-dialog.component.html',
  styleUrls: ['./search-patient-type-dialog.component.css']
})
export class SearchPatientTypeDialogComponent implements OnInit {

  selectedRowIndex: number = -1;

  generalFilter = new FormControl();
  filteredValues = {
    pTypeDesc: ''
  };
  


  constructor(public activeModal: NgbActiveModal,
    private router: Router,
    private customConfirmDialogService: CustomConfirmDialogService,
    private log: LoggerService,
    private route: ActivatedRoute,
    private tPatientTypeService: tPatientTypeService,) { }

    dataSource: MatTableDataSource<tPatientTypeModel>;
    // dataList: tShopModel[];
    private TAG = 'SearchPatientTypeDialogComponent';

  
    @ViewChild(MatPaginator) paginator: MatPaginator;

    // displayMsg: string;
    @Input() action: string;
    @Input() status: string;
    @Input() tableKeyValue: string;
    @Input() msg: string;


    displayedColumns: string[] = [
      // 'action_button_title',
      // 'shopID',
      'pTypeID',
      // 'pTypeDefault',
      'pTypeDesc',
      // 'pTypeColour',
      // 'pTypeRemark1',
      // 'pTypeRemark2',
      // 'lastModifyDatetime',
      // 'LastModifyUserID'

    ];

  ngOnInit() {
    this.getAllData();
  }

  getAllData(): void {
    this.log.i(this.TAG, 'getAllProducts');

    this.tPatientTypeService.getAllData().subscribe(data => {
      //  this.dataList = data;

      this.dataSource = new MatTableDataSource<tPatientTypeModel>(data);
      this.log.i(this.TAG,'getAllData = ' + JSON.stringify(data));
      this.dataSource.paginator = this.paginator;
      // this.log.i(this.TAG,"data.pTypeDesc = "+filter);

      this.generalFilter.valueChanges.subscribe((generalFilterValue) => {
        this.filteredValues['pTypeDesc'] = generalFilterValue;
        this.dataSource.filter = JSON.stringify(this.filteredValues);
      });

      this.dataSource.filterPredicate = this.customFilterPredicate();





    });
  }

  customFilterPredicate() {
    const myFilterPredicate = (data: tPatientTypeModel, filter: string): boolean => {

      let searchString = JSON.parse(filter);

      return (searchString.pTypeDesc.toLowerCase() == '' || 
      (data.pTypeDesc != null 
        && data.pTypeDesc.toString().trim().toLowerCase().indexOf(searchString.pTypeDesc.toLowerCase()) !== -1))
      ;

    }

    return myFilterPredicate;
  }



  selectRow(selectedModel: tPatientTypeModel, index: number) {

    this.log.i(this.TAG, selectedModel.pTypeID.toString());

    this.selectedRowIndex = index;


    switch (this.tableKeyValue) {
      case MastersKeyStringValue.TABLE_ItemCate:
        this.tPatientTypeService.priceBookShareSelected(selectedModel);
        break;
      case MastersKeyStringValue.TABLE_PriceBook:
        // this.tPatientTypeService.priceBookShareSelected(selectedModel);
        break;
      default:
        this.tPatientTypeService.priceBookShareSelected(selectedModel);
        break;
    }


    this.activeModal.close(selectedModel);
  }

}
